import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const MOOD_EMOJIS = { 1: '😔', 2: '😐', 3: '🙂', 4: '😊', 5: '🤩' };
const PAGE_SIZE = 5;

export default function ReflectionHistory({ logs }) {
  const [visiveis, setVisiveis] = useState(PAGE_SIZE);

  const entries = logs.filter(l => l.completed);

  if (!entries.length) {
    return <p className="empty">Ainda sem entradas. Comece hoje! 🌱</p>;
  }

  const exibidas = entries.slice(0, visiveis);
  const temMais = visiveis < entries.length;
  const proximas = Math.min(PAGE_SIZE, entries.length - visiveis);

  return (
    <div className="reflection-history">
      {exibidas.map(log => (
        <div key={log.date} className="reflection-entry">
          <div className="reflection-entry-mood">
            {MOOD_EMOJIS[log.mood_score] || '📓'}
          </div>
          <div className="reflection-entry-body">
            <div className="reflection-entry-date">
              {format(parseISO(log.date), "EEEE, d 'de' MMMM", { locale: ptBR })}
            </div>
            {log.note
              ? <p className="reflection-entry-text">{log.note}</p>
              : <p className="reflection-entry-no-note">Sem reflexão registrada</p>
            }
          </div>
        </div>
      ))}

      {temMais && (
        <button
          className="btn btn-ghost feed-carregar-mais"
          onClick={() => setVisiveis(v => v + PAGE_SIZE)}
        >
          Ver mais {proximas} reflexões
        </button>
      )}
    </div>
  );
}
